import JobLeftListContainer from "../../../components/job/listing/JobLeftList";

const JobLeftList = () => {
  return <JobLeftListContainer />;
};

export default JobLeftList;
